// extracted by mini-css-extract-plugin
export var animationContainer = "_ah-0";
export var asteriskIcon = "_ah-8";
export var conversationLeftSection = "_ah-4";
export var conversationListItem = "_ah-3";
export var conversationMiddleSection = "_ah-5";
export var conversationRightSection = "_ah-6";
export var detailsContent = "_ah-1";
export var listContainer = "_ah-7";
export var modalContent = "_ah-2";